import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundDocument.Save.IRequest;
type Response = Api.Sales.ContractRefundDocument.Save.IResponse;
type Headers = Api.Sales.ContractRefundDocument.Save.IHeaders;
const url = '/api/Sales/ContractRefund/:id/Documents';
export default async function contractRefundDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.contractRefundId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
